import { useMediaQuery } from '../../hooks/use-media-query'
import DesktopNavbar from './desktop-navbar'
import MobileNavbar from './mobile-navbar'

export default function DashboardNavbarResponsive() {
  const isDesktop = useMediaQuery('(min-width: 1000px)')

  return (
    <div
      className="fixed top-0 z-50 w-full bg-white"
      style={{
        fontFamily: 'BebasNeue, "Helvetica Neue", Helvetica, Arial, sans-serif',
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgb(221, 221, 221) 0px -1px 0px 0px inset',
      }}
    >
      {isDesktop ? <DesktopNavbar /> : <MobileNavbar />}
    </div>
  )
}
